import { css } from 'lit'

export default css`
  html {
    font-size: 62.5%;
  }

  body,
  .body,
  .p,
  p,
  .body-large,
  .h1,
  h1,
  .h2,
  h2,
  .h3,
  h3,
  .h4,
  h4,
  .h5,
  h5,
  .h6,
  h6,
  .utility,
  .caption,
  .pullquote,
  .bullet-list,
  .inline-link {
    color: var(--hh-color-aged-black);

    /* to ensure reset re: Chrome native margins: */
    margin: 0;
  }

  body,
  .body,
  .p,
  p {
    font: var(--hh-body-font);
    letter-spacing: var(--hh-body-letter-spacing);
    text-transform: var(--hh-body-text-transform);
  }

  .body-large {
    font: var(--hh-body-font-large);
  }

  h1,
  .h1 {
    font: var(--hh-h1-font);
    letter-spacing: var(--hh-h1-letter-spacing);
    text-transform: var(--hh-h1-text-transform);
    text-decoration: var(--hh-text-decoration-underline);
  }

  h2,
  .h2 {
    font: var(--hh-h2-font);
    letter-spacing: var(--hh-h2-letter-spacing);
    text-transform: var(--hh-h2-text-transform);
    text-decoration: none;
  }

  h3,
  .h3 {
    font: var(--hh-h3-font);
    letter-spacing: var(--hh-h3-letter-spacing);
    text-transform: var(--hh-h3-text-transform);
    text-decoration: var(--hh-text-decoration-underline);
  }

  h4,
  .h4 {
    font: var(--hh-h4-font);
    letter-spacing: var(--hh-h4-letter-spacing);
    text-transform: var(--hh-h4-text-transform);
  }

  h5,
  .h5 {
    font: var(--hh-h5-font);
    letter-spacing: var(--hh-h5-letter-spacing);
    text-decoration: none;
    text-transform: var(--hh-h5-text-transform);
  }

  h6,
  .h6 {
    font: var(--hh-h6-font);
    letter-spacing: var(--hh-h6-letter-spacing);
    text-transform: var(--hh-h6-text-transform);
    text-decoration: none;
  }

  .utility {
    font: var(--hh-body-utility);
    letter-spacing: var(--hh-utility-letter-spacing);
    text-transform: var(--hh-utility-text-transform);
  }

  .caption {
    font: var(--hh-body-caption);
    letter-spacing: var(--hh-caption-letter-spacing);
    text-transform: var(--hh-caption-text-transform);
  }

  .pullquote {
    font: var(--hh-body-pullquote);
  }

  .bullet-list {
    font: var(--hh-body-bullet-list);
  }

  .inline-link,
  .rte a {
    font: var(--hh-body-inline-link);
    text-decoration: var(--hh-text-decoration-underline);
  }

  .left {
    text-align: left;
  }

  .center {
    text-align: center;
  }

  .right {
    text-align: right;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .lowercase {
    text-transform: lowercase;
  }

  .capitalize {
    text-transform: capitalize;
  }

  .light {
    opacity: 0.7;
  }

  .break {
    word-break: break-word;
  }

  .underline {
    text-decoration: underline;
  }

  blockquote,
  blockquote * {
    font: var(--hh-body-pullquote);
  }
`
